import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableAdditionalColumns } from '@fi-shared/fi-wrapper-table/fi-wrapper-table-additional-columns';
import { IChecklistV2ForList } from '@fi-shared/checklist/checklist-v2';
import { FiChecklistHelperService } from '@fi-shared/checklist/fi-checklist-helper.service';

@Component({
    selector: 'fi-checklist2-list-start-date',
    templateUrl: './fi-checklist2-list-start-date.component.html',
    styleUrls: ['./fi-checklist2-list-start-date.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-list-start-date' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2ListStartDateComponent }],
    standalone: false,
})
export class FiChecklist2ListStartDateComponent extends FiWrapperTableAdditionalColumns {
    constructor(private fiChecklistHelperService: FiChecklistHelperService) {
        super();
    }

    isAuditOnDemandDueDateSoon(item: IChecklistV2ForList): boolean {
        return item.IsActive && this.fiChecklistHelperService.isAuditOnDemandDueDateSoon(item);
    }

    getStartTimeText(item: IChecklistV2ForList) {
        return this.fiChecklistHelperService.getStartTimeText(item, item.IsActive, item.ScheduleType);
    }
}
